import { useTranslation } from 'react-i18next';
import Stack from '@karma/components/Stack';
import { Typography } from '@karma/components';
import hasDiscount from 'functions/hasDiscount';
import checkItemHasPrice from 'functions/checkItemHasPrice';
import { AUTO_TEST_CLASS } from 'consts/autoTest';

const getConfig = (v2, isOneLinePrice, revertOrder) => {
  if (v2 && !isOneLinePrice) {
    return {
      spacing: 0,
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      direction: 'column',
    };
  }

  return {
    spacing: 6,
    justifyContent: 'flex-start',
    alignItems: 'center',
    direction: revertOrder ? 'row-reverse' : 'row',
  };
};

const Price = ({ currentPrice, originalPrice, currency, isOutOfStock, revertOrder, v2, isOneLine }) => {
  const { t } = useTranslation();

  if (isOutOfStock || !checkItemHasPrice(currentPrice?.full)) {
    return <Typography variant="labelMedium">&nbsp;</Typography>;
  }

  const showOriginalPrice = hasDiscount(currentPrice, originalPrice, currency);
  const config = getConfig(v2, isOneLine, revertOrder);

  return (
    <Stack
      spacing={config.spacing}
      justifyContent={config.justifyContent}
      alignItems={config.alignItems}
      direction={config.direction}
    >
      {showOriginalPrice && (
        <Typography
          variant={v2 ? 'paragraphSmall' : 'labelMedium'}
          color={v2 ? 'neutral7' : 'neutral2'}
          textDecoration="line-through"
          className={AUTO_TEST_CLASS.OLD_PRICE}
        >
          {t('app:price', {
            currency,
            value: Number(originalPrice?.full).toFixed(2),
          })}
        </Typography>
      )}

      <Typography variant="labelMedium" color="primary1" className={AUTO_TEST_CLASS.NEW_PRICE}>
        {t('app:price', {
          currency,
          value: Number(currentPrice?.full).toFixed(2),
        })}
      </Typography>
    </Stack>
  );
};

export default Price;
